import React from 'react'
import { useComplianceFrameworks } from 'src/components/async/complianceframework'
import { FilterName, FilterParam } from '../../FilterBar.types'
import { FilterDropdown } from '../FilterDropdown'
import { LoadingFilterDropdown } from '../FilterDropdown.components'

export const OverviewFrameworkFilterDropdown = ({
  isNested = false,
}: {
  isNested?: boolean
}): JSX.Element | null => {
  const { data: frameworks, isLoading } = useComplianceFrameworks(true)

  if (isLoading) {
    return (
      <LoadingFilterDropdown
        filterName={FilterName.DASHBOARD_FRAMEWORK}
        isNested={isNested}
      />
    )
  }

  const filterValues =
    frameworks?.getItemsList().map((framework) => ({
      value: framework.getId(),
      label: framework.getName(),
    })) || []

  if (!filterValues.length) return null

  return (
    <FilterDropdown
      filterParam={FilterParam.DASHBOARD_FRAMEWORK}
      filterName={FilterName.DASHBOARD_FRAMEWORK}
      filterValues={filterValues}
      isNested={isNested}
    />
  )
}
